<template>
  <form @submit.prevent="submitForm" method="POST">
    <div class="md:flex flex-wrap justify-between items-center border-t border-grey-lighter mt-3 pt-3">
      <p class="text-lg text-brown mr-auto mb-0">{{ ticketName }}</p>
      
      <div class="inline-flex items-center" v-if="ticketName == 'Club Member' && member == 0">
        <span class="inline-block text-lg mr-4">{{ ticketPrice }}</span>
        <a class="block min-w-sm text-right ml-4" :href="'/login?redirect=' + redirect">Log in to purchase</a>
      </div>

      <div class="inline-flex items-center text-right" v-else-if="available < 1">
        <strong>Sold out</strong>
      </div>

      <div class="inline-flex items-center" v-else>
        <span class="inline-block text-lg mr-4">{{ ticketPrice }}</span>
        <qty-input 
          class="inline mb-0 mr-4"
          :showLabel="false"
          ref="qtyInput"
          input-name="`item[${ticketId}][qty]`"></qty-input>

        <button type="submit" class="btn">
          <transition name="fade" mode="out-in">
            <vue-simple-spinner v-if="loading"  :size="16" :line-size="2" line-bg-color="#D1865F" line-fg-color="#FFF" />
            <span v-else>Add to Cart</span>
          </transition>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import { EventBus } from "../lib/event-bus.js";
import QtyInput from "./shop/QtyInput";
import VueSimpleSpinner from 'vue-simple-spinner';

export default {
  props: {
    eventId: {
      required: true
    },
    ticketId: {
      required: true
    },
    ticketName: {
      required: true
    },
    ticketPrice: {
      required: true
    },
    available: {
      required: true
    },
    member: {
      required: true
    },
    redirect: {
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  },

  components: {
    VueSimpleSpinner,
    QtyInput
  },

  methods: {
    unescape(str) {
      return json(str)
    },

    submitForm(event) {
      // example of looping through form, needs polyfills
      // const formData = new FormData(event.target);
      // for (const pair of formData.entries()) {
      //   params.append(
      //     encodeURIComponent(pair[0]),
      //     encodeURIComponent(pair[1])
      //   );
      // }

      this.loading = true;

      // use URLSearchParams to format data as application/x-www-form-urlencoded for Craft2
      let params = new URLSearchParams();
      params.append(this.$root.$options.csrf.name, this.$root.$options.csrf.value);
      params.append('action', 'events/cart/add');
      params.append('event', this.eventId);
      params.append(`item[${this.ticketId}][qty]`, this.$refs.qtyInput.qty);

      axios({
        method: 'post',
        url: '/',
        data: params,
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((response) => {
        this.loading = false;
        EventBus.$emit('open-cart', { reload: true });
      })
      .catch((error) => {
        this.loading = false;
        console.log('Add to Cart Error:', error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/EventTicket.vue